/**
 * Stable, registered business identities for requests entering Search Platform from AFM.
 *
 * Naming convention: <domain>.<business-purpose>[.<sub-purpose>]
 *
 * Never add:
 * - per-user, session, request, or tenant values
 * - targeting or experiment values
 * - search behaviour or operation names
 *
 * Alexander owns the authoritative runtime registry. Keep this client catalog aligned through the
 * Search use-case registration runbook before rolling out a new value.
 */
export const SEARCH_USE_CASE_IDS = {
	/**
	 * Registered migration bucket for AFM requests whose durable business owner cannot yet be
	 * resolved. Use only at an explicit business boundary; never as a transport-layer default.
	 */
	AFM_UNATTRIBUTED: 'afm.unattributed',
	QUICK_FIND: 'search-interactive.quick-find',
	SEARCH_PAGE: 'search-interactive.search-page',
} as const;

export type SearchUseCaseId = (typeof SEARCH_USE_CASE_IDS)[keyof typeof SEARCH_USE_CASE_IDS];
